import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-right', 'ArrowRight', [["path",{"d":"M4.5 12h15m0 0-5.625-6m5.625 6-5.625 6","key":"svg-0"}]]);